import type { Role, SessionContextKind } from "../types/user.js";

// Keyed by `Role` so a new role fails to compile until it is given a kind.
const sessionContextKindByRole: Record<Role, SessionContextKind> = {
  assessor: "case-work",
  responsible_user: "case-work",
  approver: "case-work",
  viewer: "case-work",
  organisation_admin: "organisation_administration",
  thalamos_admin: "thalamos_administration",
};

export const sessionContextKindOf = (role: Role): SessionContextKind =>
  sessionContextKindByRole[role];
